var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.771,
    height: 77.771,
    viewBox: "0 0 77.771 77.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support",
    transform: "translate(-176.214 -176.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M473.642,238.084h2.881a1.44,1.44,0,1,0,0-2.88h-1.441v-5.762a1.44,1.44,0,0,0-2.88,0v7.2a1.439,1.439,0,0,0,1.44,1.44Z",
    transform: "translate(-238.379 -41.707)",
    fill: "#2b7dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M216.09,472.2h-1.44a1.44,1.44,0,1,0,0,2.88h1.44a1.44,1.44,0,0,0,0-2.88Z",
    transform: "translate(-29.795 -238.375)",
    fill: "#2b7dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M254.531,472.2h-2.881a1.44,1.44,0,1,0,0,2.88h1.44v7.2h0a1.44,1.44,0,0,0,2.88,0V473.64a1.439,1.439,0,0,0-1.44-1.44Z",
    transform: "translate(-59.595 -238.375)",
    fill: "#2b7dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M518.042,267.883h1.44a1.44,1.44,0,0,0,0-2.88h-1.44a1.44,1.44,0,0,0,0,2.88Z",
    transform: "translate(-274.136 -71.506)",
    fill: "#2b7dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M249.664,199.26h-16a2.728,2.728,0,0,1-2.725-2.725v-16a4.325,4.325,0,0,0-4.321-4.321H203.578a4.325,4.325,0,0,0-4.321,4.321v16a2.728,2.728,0,0,1-2.725,2.725h-16a4.325,4.325,0,0,0-4.321,4.321v23.043a4.325,4.325,0,0,0,4.321,4.321h16a2.728,2.728,0,0,1,2.725,2.725v16a4.325,4.325,0,0,0,4.321,4.321h23.043a4.325,4.325,0,0,0,4.321-4.321v-16a2.727,2.727,0,0,1,2.725-2.725h16a4.325,4.325,0,0,0,4.321-4.321V203.58a4.325,4.325,0,0,0-4.321-4.321Zm1.44,27.364a1.441,1.441,0,0,1-1.44,1.44h-16a5.612,5.612,0,0,0-5.606,5.606v16a1.441,1.441,0,0,1-1.44,1.44H203.578a1.442,1.442,0,0,1-1.441-1.44v-16a5.612,5.612,0,0,0-5.6-5.606h-16a1.442,1.442,0,0,1-1.441-1.44V203.581a1.443,1.443,0,0,1,1.441-1.441h16a5.612,5.612,0,0,0,5.6-5.6v-16a1.443,1.443,0,0,1,1.441-1.441h23.043a1.442,1.442,0,0,1,1.44,1.441v16a5.612,5.612,0,0,0,5.606,5.6h16a1.442,1.442,0,0,1,1.44,1.441Z",
    fill: "#2b7dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M313.523,324.2H303.441a1.44,1.44,0,0,0,0,2.881h8.641v5.761h-8.641a1.44,1.44,0,0,0-1.44,1.44v8.641a1.441,1.441,0,0,0,1.44,1.441h10.082a1.44,1.44,0,0,0,0-2.881h-8.641v-5.761h8.641a1.441,1.441,0,0,0,1.44-1.441V325.64a1.441,1.441,0,0,0-1.44-1.44Z",
    transform: "translate(-101.304 -119.181)",
    fill: "#2b7dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M394.926,324.2a1.44,1.44,0,0,0-1.44,1.44v7.2h-7.2v-7.2a1.44,1.44,0,0,0-2.88,0v8.641a1.441,1.441,0,0,0,1.44,1.441h8.641v7.2h0a1.44,1.44,0,1,0,2.881,0V325.639a1.441,1.441,0,0,0-1.441-1.44Z",
    transform: "translate(-166.864 -119.18)",
    fill: "#2b7dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M399.638,208.69h1.44v2.881h0a1.44,1.44,0,1,0,2.881,0V207.25a1.441,1.441,0,0,0-1.441-1.44h-2.88a1.44,1.44,0,1,0,0,2.881Z",
    transform: "translate(-178.778 -23.833)",
    fill: "#2b7dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M414.442,257.61a1.44,1.44,0,0,0-1.44,1.441v1.44a1.44,1.44,0,0,0,2.881,0v-1.44a1.441,1.441,0,0,0-1.441-1.441Z",
    transform: "translate(-190.701 -65.552)",
    fill: "#2b7dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M520.915,324.2h-2.88a1.44,1.44,0,0,0,0,2.881h1.44V331.4a1.44,1.44,0,0,0,2.881,0v-5.762a1.441,1.441,0,0,0-1.441-1.44Z",
    transform: "translate(-274.131 -119.18)",
    fill: "#2b7dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M532.832,383.4a1.44,1.44,0,0,0-1.44,1.44v1.44a1.44,1.44,0,1,0,2.881,0v-1.44a1.441,1.441,0,0,0-1.441-1.44Z",
    transform: "translate(-286.048 -166.858)",
    fill: "#2b7dbd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.0e2b49b67c7deecff64d0dd28f68289f.svg";
export { ForwardRef as ReactComponent };